import { Navigate, Route, Routes } from 'react-router-dom'
import { ShipmentPage } from './shipment/detail/ShipmentPage'
import { About } from '../common/components/about/About'
import { ShipmentsSearch } from './shipment/search/ShipmentsSearch'
import { GoodsHolderPage } from './goodsholders/GoodsHolderPage'
import { LoginCallback } from '@okta/okta-react'
import { OktaError } from '../common/components/error/Error'
import { RequiredAuth } from '../common/components/authenticatedroute/AuthenticatedRoute'
import { ShipmentEventsPage } from './shipment/events/ShipmentEventsPage'
import { OrdersSearch } from './order/search/OrdersSearch'

export default function Routing() {
  return (
    <Routes>
      <Route element={<RequiredAuth />}>
        <Route path="shipments/" element={<ShipmentsSearch />} />
        <Route path="shipments/:search" element={<ShipmentsSearch />} />
        <Route path="orders/" element={<OrdersSearch />} />
        <Route path="about" element={<About />} />
        <Route path="shipment/:packlistNumber" element={<ShipmentPage />} />
        <Route path="events/:packlistNumber" element={<ShipmentEventsPage />} />
        <Route path="carton/:goodsHolderNumber" element={<GoodsHolderPage />} />
        <Route path="*" element={<Navigate to="/shipments" replace />} />
      </Route>
      <Route path="implicit/callback" element={<LoginCallback errorComponent={OktaError} />} />
    </Routes>
  )
}
